<template>
  <div>
    <UserGuidVue :picsdata="pics">
      </UserGuidVue>
  </div>
</template>

<script>
import UserGuidVue from '../components/UserGuid.vue'

export default {
  name: 'Vivo',
  data () {
    return {
      pics: [
        { url: require('../assets/vivo1.png'), text: '点击设置' },
        { url: require('../assets/vivo2.png'), text: '点击我的设备' },
        { url: require('../assets/vivo3.png'), text: '点击更多参数' },
        { url: require('../assets/vivo4.png'), text: '连续点击软件版本号7次' },
        { url: require('../assets/vivo5.png'), text: '返回设置，找到系统管理，点击开发者模式' },
        { url: require('../assets/vivo6.png'), text: '打开USB调试，（部分机型需要打开USB模拟点击）' }
      ]
    }
  },
  components: {
    UserGuidVue
  }
}
</script>

<style>

</style>
